import React, { useState, useEffect } from 'react';
import { statusService } from '../../services';
import { DataTable } from '../../components';
import { useSideDialog, useModalDialog, useGlobalState, useMessage } from '../../hooks';
import { handleError, Status, Role } from '../../helpers';

export const Statuses = () => {
  const [statuses, setStatuses] = useState([]);
  const [loggedInUser] = useGlobalState('loggedInUser');
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const clearSelectedItems = () => {
    setSelectedItems([]);
  };

  const { showMessage } = useMessage();
  const { showSideDialog, hideSideDialog, setSideDialog } = useSideDialog(clearSelectedItems);
  const { showModalDialog, hideModalDialog } = useModalDialog();

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    statusService
      .getAll()
      .then(res => {
        setStatuses(
          res.statuses.map(x => ({
            ...x,
          }))
        );
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        showMessage(err, 'error');
      });
  };

  const addStatus = async data => {
    const props = { statuses: [data] };

    await statusService
      .create(props)
      .then(res => {
        setSideDialog(prev => ({ ...prev, formErrors: {} }));
        fetchItems();
        showMessage(res.message);
      })
      .catch(err => {
        handleError({ err, showMessage, setSideDialog });
        throw err;
      });
  };

  const editStatus = async data => {
    const props = { statuses: Array.isArray(data) ? data : [data] };

    await statusService
      .update(props)
      .then(async res => {
        fetchItems();
        showMessage(res.message);
        clearSelectedItems();
        hideSideDialog();
      })
      .catch(err => {
        handleError({ err, showMessage, setSideDialog });
        throw err;
      });
  };

  const deleteStatus = async data => {
    await statusService
      .destroy({ statuses: data })
      .then(async res => {
        hideModalDialog();
        clearSelectedItems();
        fetchItems();
        showMessage(res.message);
      })
      .catch(err => {
        showMessage(err, 'error');
      });
  };

  const editable = loggedInUser && loggedInUser.user_role_name === Role.admin;

  const booleanValues = {
    true: { label: 'Yes', className: 'pill pill-black' },
    false: { label: 'No', className: 'pill pill-grey' },
  };

  return (
    <DataTable
      columns={[
        {
          id: 'status_name',
          name: 'Status',
          tooltip: 'status_description',
          className: 'bold',
        },
        {
          id: 'status_name',
          name: 'Appearance',
          type: 'pill',
          value: 'status_stage',
          values: Status,
          tooltip: 'status_name',
        },
        { id: 'status_description', name: 'Description', viewMode: 'descriptions' },
        {
          id: 'status_asset_category',
          name: 'Asset Category',
          className: 'small-text',
        },
        { id: 'status_is_default', name: 'Is Default', type: 'boolean', values: booleanValues },
      ]}
      buttons={[
        {
          label: '+ Add',
          action: 'add',
          mainButton: true,
          onClick: items => showSideDialog('addStatus', items || selectedItems, addStatus),
        },
        {
          label: 'Edit',
          action: 'edit',
          onClick: items => showSideDialog('editStatus', items || selectedItems, editStatus),
        },
        {
          label: 'Delete',
          action: 'delete',
          onClick: items => showModalDialog('deleteStatus', items || selectedItems, deleteStatus),
        },
      ]}
      data={statuses}
      idColumn="status_id"
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      loading={loading}
      filterable={true}
      editable={editable}
      filterObjects={['status_name', 'status_description', 'status_asset_category']}
      showViewModes={true}
    />
  );
};
